// extracted by mini-css-extract-plugin
export var active = "_kb-e";
export var blink = "_kb-f";
export var dropDownSelector = "_kb-5";
export var dropDownWrapper = "_kb-4";
export var fakeCursor = "_kb-d";
export var fontSizeButton = "_kb-7";
export var formQuillEditor = "_kb-0";
export var pressed = "_kb-g";
export var qlBlank = "_kb-1";
export var textFormattingToolbar = "_kb-2";
export var textFormattingToolbarClosed = "_kb-3";
export var textFormattingToolbarInline = "_kb-6";
export var textToolbarOption = "_kb-8";
export var toolbarCell = "_kb-a";
export var toolbarCellCollapsed = "_kb-b";
export var toolbarOptionHitArea = "_kb-c";
export var toolbarOverflow = "_kb-9";